import { render, staticRenderFns } from "./LadaItems.vue?vue&type=template&id=7b856fe4"
import script from "./LadaItems.vue?vue&type=script&lang=js"
export * from "./LadaItems.vue?vue&type=script&lang=js"
import style0 from "./LadaItems.vue?vue&type=style&index=0&id=7b856fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports